
import React, { Component, PureComponent } from "react";
import { PieChart, Pie, Sector, Cell, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { connect } from 'react-redux'
import { MESSAGE } from '../../../../constants/dictionaries'


//component

import { Table, Row, Col } from 'antd';
import message from "../../../../components/Messages";
import Api_tnn from '../../../../api/api.tnn';
import Api_quantrac from '../../../../api/api.quantrac'


class SoLieu extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: []
        }
    }
    componentDidMount() {
     this.getgp();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
    }
    getgp = async () => {
        try {
            const dataquantrac = await new Api_quantrac().tongso_gp({ token: this.props.user.access_token })
            if (dataquantrac) {
                this.setState({
                    data:[
                        { name: 'Hiện trạng môi trường', tittle: "BÁO CÁO QUAN TRẮC MÔI TRƯỜNG KHÁC", value: dataquantrac ? dataquantrac.count_htmt_bcdk : 0, backGroundColor: '#5d9cec' },
                        { name: ' Thủy sản', value: dataquantrac ? dataquantrac.count_ntts_bcdk : 0, backGroundColor: '#656565b8' },
                        { name: 'Vịnh Hạ Long ', value: dataquantrac ? dataquantrac.count_qtvinhhalong_bcdk : 0, backGroundColor: '#d8b844' },
                    ]
                })
            }
        } catch (err) {
            message.error(err.message)
        }
    }


    render() {
        const { data } = this.state

        return (
            <Row>
                <Col style={{height:295}}>
                    <div className="tieudetrangchu">
                        {data && data.length > 0 && data[0].tittle}
                    </div>
                    <div>
                    {data.map((item,index) => 
                    <div className="title_moitruong" >{item.name + ": "+ item.value}</div>)}
                    </div>
                    
                </Col>
            </Row>

        );
    }
}




const mapStateToProps = (state) => ({ user: state.oidc.user });

export default connect(mapStateToProps)(SoLieu);